/**
 * Tabs of the Configuration page that other parts of the app link to directly
 * (`/configuration?tab=<key>`), e.g. the header's user menu.
 */
export const CONFIGURATION_TAB_QUERY_PARAM = 'tab';

export type ConfigurationLinkedTab = 'profile' | 'password' | 'preferences';

export const DEFAULT_CONFIGURATION_TAB: ConfigurationLinkedTab = 'profile';

/** The URL that opens the Configuration page on the given tab. */
export const configurationTabPath = (tab: ConfigurationLinkedTab): string =>
    `/configuration?${CONFIGURATION_TAB_QUERY_PARAM}=${tab}`;

/**
 * The tab to show for a requested key. A key the current user cannot see (e.g. the
 * admin-only workstations tab) or one that does not exist falls back to the first
 * tab rather than rendering an empty tab strip selection.
 */
export const resolveConfigurationTab = (
    requested: string | null,
    availableKeys: readonly string[],
): string => {
    if (requested !== null && availableKeys.includes(requested)) {
        return requested;
    }
    return availableKeys[0] ?? DEFAULT_CONFIGURATION_TAB;
};
